import { SnackbarNotification } from './notification.types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type NotificationState = {
    currentNotification: SnackbarNotification;
    next: SnackbarNotification[];
};

const initialState = {
    currentNotification: null,
    next: [],
};

export const notificationSlice = createSlice({
    name: 'notificationSlice',

    initialState,

    reducers: {
        addNotification(
            state: NotificationState,
            action: PayloadAction<SnackbarNotification>
        ) {
            const notification = action.payload;

            if (!state.currentNotification) {
                state.currentNotification = notification;
            } else {
                state.next.push(notification);
            }

            return state;
        },

        consumeNext(state: NotificationState) {
            state.currentNotification = state.next.shift();

            return state;
        },

        clearNotifications() {
            return initialState;
        },
    },
});

export const notificationActions = {
    ...notificationSlice.actions,
};
